import "./Home.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically from "./sections/TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically";
import ProvenImpact from "./sections/ProvenImpact";
import PerformanceBenchmarks from "./sections/PerformanceBenchmarks";
import NextSteps from "./sections/NextSteps";
import VisibilityTraffic from "./sections/VisibilityTraffic";
import ThreeSimpleSteps from "./sections/ThreeSimpleSteps";
import LearnNewSkills from "./sections/LearnNewSkills";
import HumanStandardPerformance from "./sections/HumanStandardPerformance";
import OgrenciVeOgretmenGorusleri from "./sections/OgrenciVeOgretmenGorusleri";
import InstantReportAccess from "./sections/InstantReportAccess";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavigationHeader />
      <TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically />
      <ProvenImpact />
      <PerformanceBenchmarks />
      <NextSteps />
      <VisibilityTraffic />
      <ThreeSimpleSteps />
      <LearnNewSkills />
      <HumanStandardPerformance />
      <OgrenciVeOgretmenGorusleri />
      <InstantReportAccess />
      <Footer />
    </div>;
}